import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "pagination-wrapper justify-space-between flex mt-2.5 flex-wrap" };
const _hoisted_3 = { class: "total-items align-content-center text-[#8D9DA8] whitespace-nowrap mr-0.5" };
const _hoisted_4 = { class: "pagination-component-wrapper align-center pb-1 flex gap-2.5" };
const _hoisted_5 = { class: "label-wrapper mr-2 flex w-28.75 align-center p-1.25 pl-0 whitespace-nowrap text-[#8D9DA8] my-auto" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (!$props.hideFooter)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString($setup.t('common.totalItems', { totalItems: $props.totalItems ? $props.totalItems.toLocaleString() : 0 })), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", null, _toDisplayString($setup.t('common.itemsPerPage')), 1 /* TEXT */)
                    ]),
                    _createVNode($setup["EnMenu"], {
                        ref: "itemsPerPageMenu",
                        align: "end",
                        side: "bottom",
                        class: "flex flex-col gap-1 p-1 min-w-0 rounded-1 z-2500"
                    }, {
                        trigger: _withCtx(() => [
                            _createVNode($setup["EnButton"], {
                                variant: "outline",
                                size: "sm",
                                "static-id": $setup.buildId(),
                                class: "items-per-page-selector my-auto px-2 h-8 justify-between gap-1 shadow-none text-en-blue-400"
                            }, {
                                append: _withCtx(() => [
                                    _createVNode($setup["ChevronDown"], { class: "size-4" })
                                ]),
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($setup.paginationOptions.itemsPerPage) + " ", 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["static-id"])
                        ]),
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.footerProps.itemsPerPageOptions, (option) => {
                                return (_openBlock(), _createBlock($setup["EnMenuItem"], {
                                    key: option,
                                    active: option === $setup.paginationOptions.itemsPerPage,
                                    onClick: ($event) => ($setup.selectItemsPerPage(option))
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(option), 1 /* TEXT */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["active", "onClick"]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        _: 1 /* STABLE */
                    }, 512 /* NEED_PATCH */),
                    _createVNode($setup["Pagination"], {
                        total: $props.totalItems,
                        "items-per-page": $setup.paginationOptions.itemsPerPage,
                        page: $setup.paginationOptions.page,
                        "sibling-count": 1,
                        "show-edges": "",
                        "onUpdate:page": $setup.updatePage
                    }, {
                        default: _withCtx(() => [
                            _createVNode($setup["PaginationContent"], { class: "gap-2" }, {
                                default: _withCtx(({ items }) => [
                                    _createVNode($setup["PaginationItem"], {
                                        value: $setup.paginationOptions.page - 1,
                                        disabled: $setup.paginationOptions.page === 1
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode($setup["EnButton"], {
                                                disabled: $setup.paginationOptions.page === 1,
                                                variant: "ghost",
                                                class: "size-8"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode($setup["ChevronLeft"])
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["disabled"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["value", "disabled"]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.filter(i => i.type === 'page' || i.type === 'ellipsis'), (item, index) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                            (item.type === 'page')
                                                ? (_openBlock(), _createBlock($setup["PaginationItem"], {
                                                    key: 0,
                                                    value: item.value,
                                                    class: _normalizeClass(`size-8 ${item.value === $setup.paginationOptions.page ? 'bg-accent text-accent-foreground' : ''}`)
                                                }, null, 8 /* PROPS */, ["value", "class"]))
                                                : (_openBlock(), _createBlock($setup["PaginationEllipsis"], {
                                                    key: 1,
                                                    index: index
                                                }, null, 8 /* PROPS */, ["index"]))
                                        ], 64 /* STABLE_FRAGMENT */));
                                    }), 128 /* KEYED_FRAGMENT */)),
                                    _createVNode($setup["PaginationItem"], {
                                        value: $setup.paginationOptions.page + 1,
                                        disabled: $setup.paginationOptions.page === $setup.totalPages
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode($setup["EnButton"], {
                                                disabled: $setup.paginationOptions.page === $setup.totalPages,
                                                variant: "ghost"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode($setup["ChevronRight"])
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["disabled"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["value", "disabled"])
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["total", "items-per-page", "page"])
                ])
            ])
        ]))
        : _createCommentVNode("v-if", true);
}
